/**
 * @generated SignedSource<<af5959b2a554643be798d07160eaa0ed>>
 * @relayHash cd94638f0a751a2535b18a29d5e79b86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d5bbb0ebe3225a7395c9688697e617fa2df2453a1f7922b19244f6231d82c779

import type { ConcreteRequest } from 'relay-runtime';
export type TeamCustomFieldCardinality = "MULTI" | "SINGLE" | "%future added value";
export type TeamCustomFieldType = "NUMBER" | "SELECTOR" | "STRING" | "TEAM" | "USER" | "%future added value";
export type TeamCreateCustomFieldPayload = {
  cardinality: TeamCustomFieldCardinality;
  description?: string | null;
  name: string;
  options?: ReadonlyArray<string> | null;
  scope?: TeamCustomFieldScopeInput | null;
  type: TeamCustomFieldType;
};
export type TeamCustomFieldScopeInput = {
  teamTypeId?: string | null;
  userbase?: boolean | null;
};
export type CreateCustomFieldMutation$variables = {
  customFieldData: TeamCreateCustomFieldPayload;
  scopeId: string;
};
export type CreateCustomFieldMutation$data = {
  readonly team: {
    readonly createCustomField: {
      readonly description: string | null;
      readonly id: string;
      readonly name: string;
      readonly teamType: {
        readonly id: string;
        readonly name: string;
        readonly verified: boolean | null;
      } | null;
      readonly type: TeamCustomFieldType;
    } | null;
  } | null;
};
export type CreateCustomFieldMutation = {
  response: CreateCustomFieldMutation$data;
  variables: CreateCustomFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customFieldData"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scopeId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "concreteType": "TeamMutation",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "customFieldData",
            "variableName": "customFieldData"
          },
          {
            "kind": "Variable",
            "name": "scopeId",
            "variableName": "scopeId"
          }
        ],
        "concreteType": "TeamDetailedCustomFieldInfo",
        "kind": "LinkedField",
        "name": "createCustomField",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "concreteType": "TeamType",
            "kind": "LinkedField",
            "name": "teamType",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "verified"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CreateCustomFieldMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateCustomFieldMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "d5bbb0ebe3225a7395c9688697e617fa2df2453a1f7922b19244f6231d82c779",
    "metadata": {},
    "name": "CreateCustomFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f0a0155b844e8505dca0868580e2c8b7";

export default node;
